import axiosInstance from './axiosConfig';
import type { CommunityMessageLinkPreview } from './communityService';

import { extractCommunityInviteFromText } from '../utils/communityInviteUrl';

export async function fetchLinkPreview(url: string): Promise<CommunityMessageLinkPreview | null> {
  try {
    const res = await axiosInstance.get<{ preview: CommunityMessageLinkPreview }>(
      '/api/communities/link-preview',
      { params: { url } }
    );
    return res.data.preview ?? null;
  } catch {
    return null;
  }
}

export const URL_IN_TEXT_REGEX =
  /(?:https?:\/\/[^\s<>"']+|(?:localhost(?::\d+)?|(?:[\w-]+\.)+[\w-]{2,})(?:\/[^\s<>"']*)?)/i;

export function extractFirstUrl(text: string): string | null {
  const invite = extractCommunityInviteFromText(text);
  if (invite) return invite.href;

  const match = text.match(URL_IN_TEXT_REGEX);
  if (!match?.[0]) return null;

  const url = match[0];
  if (/^https?:\/\//i.test(url)) return url;
  return url.startsWith('localhost') || url.startsWith('127.')
    ? `http://${url}`
    : `https://${url}`;
}
